import CryptoJS from 'crypto-js';

  //加密
  function encrypt(word) {
    var keyStr = "NYZY3BTQGV156PKA"; //本VUE项目需要和管理项目的AES密钥完全一致
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  }
  //解密
function decrypt(word) {
    var keyStr = "NYZY3BTQGV156PKA" //本VUE项目需要和管理项目的AES密钥完全一致
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }

export {
  encrypt,
  decrypt
}



// WEBPACK FOOTER //
// ./src/common/aes.js